import React from "react";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";

const MidCallTransfer = () => (
  <SummaryItem itemKey={"Mid-Call Transfer: "}>
    <SectionItem itemKey={"Enabled"}>True</SectionItem>
  </SummaryItem>
);

export default MidCallTransfer;
